import axios from "axios";

export default {
    // 获取商品销售列表
    getSalesList: function (params) {
        return axios.get('/w1/bi/sales/list', { params: params })
    },
    // 获取商品销售数据
    // GetSalesDataBySku: function (sku,params) {
    //     return axios.get(`/w1/bi/sales/GetSalesDataBySku/${sku}/`,{params:params})
    // },
    // 获取到历史占比
    // GetHistoryPercent: function (sku,params) {
    //     return axios.get(`/w1/bi/sales/GetHistoryPercent/${sku}`,{params:params})
    // },
    // // 拟下单金额占比
    // GetXdPrice: function (sku,params) {
    //     return axios.get(`/w1/bi/sales/xdprice/${sku}`,{params:params})
    // },

    //====================================
    //============= 畅销排行榜
    //====================================
    // 获取畅销排行榜
    GetSalesRank: function (params) {
        return axios.get('/w1/bi/sales/salesKing', { params: params })
    },
    // 获取到销量价格
    GetSalesMoney: function (sku,params) {
        console.log(sku)
        return axios.get(`/w1/bi/sales/GetSalesMoney/${sku}`, { params: params })
    },
    // 获取到下单金额和购物车金额
    GetOrderCartPrice: function (sku,params) {
        return axios.get(`/w1/bi/sales/GetOrderPriceAndCartPrice/${sku}`, { params: params })
    },
    // 获取到销量数量
    // GetSalesSumNum: function (sku,params) {
    //     return axios.get(`/w1/bi/sales/GetSalesSumNum/${sku}`, { params: params })
    // },
    // 获取到历史补货数量
    GetHistoryBhNum:function (sku,params) {
        return axios.get(`/w1/bi/sales/GetHistoryBhNum/${sku}`, { params: params })
    },
    // //拟下单数量
    // GetXdNum:function (sku,params) {
    //     return axios.get(`/w1/bi/sales/GetXdNum/${sku}`,{ params: params })
    // },
    // //拟下单数量
    // GetCartNum:function (sku,params) {
    //     return axios.get(`/w1/bi/sales/GetCartNum/${sku}`,{ params: params })
    // },

     //====================================
    //============= 不推荐商品
    //====================================
    NotRecommended: (params) => {
        return axios.get(`/w1/bi/sales/notrecommend`, { params: params })
    },

    //====================================
    //============= 首次选购商品
    //====================================
    GetFirstBuy: function (params) {
        return axios.get('/w1/bi/sales/firstbuy', { params: params })
    },
    //已提交未审核订单+购物车数量
    GetOrderCartNumAndPrice:function (sku) {
        return axios.get(`/w1/bi/sales/GetOrderCartNumAndPrice/${sku}` )
    },
}